import { useState, useEffect } from 'react'
import { logEvent } from './eventLog.js'
import { supabase } from '../lib/supabase.js'

const LS_KEY="estoqueos_tasks";

function loadTasks(){
  try{const raw=localStorage.getItem(LS_KEY);if(raw){const parsed=JSON.parse(raw);if(Array.isArray(parsed))return parsed;}}catch(e){}
  return[];
}
function saveTasks(list){
  try{localStorage.setItem(LS_KEY,JSON.stringify(list));}catch(e){}
}

async function sbLoadTasks(){
  const{data,error}=await supabase.from('tarefas').select('*').order('created_at',{ascending:false});
  if(error||!data)return null;
  return data;
}
async function sbUpsertTask(task){
  const{error}=await supabase.from('tarefas').upsert({
    id:String(task.id),
    produto_id:task.produto_id??null,
    produto_nome:task.produto_nome??task.name??null,
    produto_sku:task.produto_sku??task.sku??null,
    solicitante:task.requestedBy??task.solicitante??null,
    motivo:task.taskLabel??task.motivo??null,
    status:task.status??'pending',
    resposta:task.resposta??null,
    created_at:task.date??task.created_at??new Date().toISOString(),
    resolved_at:task.resolved_at??null,
  },{onConflict:'id'});
  if(error)console.warn('supabase tarefas upsert error',error);
}

export let _tasks=loadTasks();
let _tl=[];
let _tReady=false;

function subTasks(fn){_tl.push(fn);return()=>{_tl=_tl.filter(f=>f!==fn);};}

function setGlobalTasks(fn){
  _tasks=fn(_tasks);
  saveTasks(_tasks);
  _tl.forEach(f=>f(_tasks));
}

async function initTasks(){
  if(_tReady)return;
  _tReady=true;
  const remote=await sbLoadTasks();
  if(remote&&remote.length>0){
    _tasks=remote;
    saveTasks(_tasks);
    _tl.forEach(f=>f(_tasks));
  }
}

function useGlobalTasks(){
  const[t,sT]=useState(_tasks);
  useEffect(()=>{
    sT(_tasks);
    const unsub=subTasks(sT);
    initTasks();
    return unsub;
  },[]);
  return[t,setGlobalTasks];
}

function addTask(task){
  const newTask={
    ...task,
    id:crypto.randomUUID(),
    date:new Date().toISOString().split("T")[0],
    created_at:new Date().toISOString(),
    status:"pending"
  };
  setGlobalTasks(prev=>[newTask,...prev]);
  sbUpsertTask(newTask);
  logEvent({tipo_evento:"DEMANDA_CRIADA",usuario:task.requestedBy||"sistema",entidade:"DEMANDA",id_entidade:task.sku,detalhes:task.taskLabel||""});
}

export { useGlobalTasks, setGlobalTasks, addTask }